import TraitsListSections from './TraitsListSections'

export default TraitsListSections
